import { eventsMapper } from './event-mapper';

import type { Action, Dispatch, MiddlewareAPI } from 'core/use-cases/utilities';

export const middleware = (api: MiddlewareAPI) => (next: Dispatch) => (action: Action) => {
  if (action?.type in eventsMapper) {
    const event: any = eventsMapper[action.type as keyof typeof eventsMapper](
      action,
      api.getState(),
    );
    if (event) {
      dataLayer.push({ ecommerce: null });

      if (Array.isArray(event)) {
        dataLayer.push(...event);
      } else {
        dataLayer.push(event);
      }
    }
  }
  return next(action);
};
